import { IStyleableProps } from 'lib/interfaces/IStyleableProps';
import React from 'react';
import { Card as ReactStrapCard } from 'reactstrap';

interface ICardProps extends IStyleableProps {
	heading?: string;
	controls?: any;
	style?: any;
}
export const Card = (props: ICardProps) => {
	return (
		<ReactStrapCard
			className={props.className ? props.className : undefined}
			style={props.style ? props.style : undefined}
		>
			{props.heading || props.controls ? 
				<div className='p-2 pt-3 row'>
					{props.heading ?
						<div className='col-md-4 col-sm-12'>
							<h4>{props.heading}</h4>
						</div> : null 
					}
					{props.controls ?
					<div className='col-md-8 col-sm-12 text-md-right text-left'>
						{props.controls}
					</div> : null
					}
				</div> : null }{' '}
			{props.children ? props.children : null}
		</ReactStrapCard>
	);
};



// WEBPACK FOOTER //
// ./src/components/common/card/Card.tsx